export enum MaterialPriceOptionEnum {
    PURCHASE_PRICE = 'PURCHASE_PRICE',
    MOVING_AVERAGE_PRICE = 'MOVING_AVERAGE_PRICE',
    PLANNING_PRICE = 'PLANNING_PRICE',
}
